/***        自定义picker      ***/
<template>
  <div id="myPicker" v-if="showPicker">
    <div class="moda"></div>
    <div class="pickerContainer">
      <div class="bar">
        <span class="cancelBtn" @click="cancel">取消</span>
        <span style="color: #000;">{{title}}</span>
        <span class="sureBtn" @click="sure">确定</span>
      </div>
      <div class="lines"></div>
      <mt-picker
        ref="picker"
        :slots="slots"
        value-key="name"
        @change="onValuesChange">
      </mt-picker>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  // import {Picker} from 'mint-ui'

  export default {
    components: {},
    name: 'myPicker',
    props: {
      title: { // 标题
        type: String,
        default: '请选择'
      },
      pickItem: {
        default () {
          let arr = [
            {name: '2015', val: 2015},
            {name: '2016', val: 2016},
            {name: '2017', val: 2017},
            {name: '2018', val: 2018}
          ]
          return arr
        }
      },
      showMyPicker: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({})
    },
    watch: {
      showMyPicker (val) {
        if (val) {
          this.showPicker = true
          this.forbidBodyScroll()
        } else {
          this.showPicker = false
          this.allowBodyScroll()
        }
      },
      pickItem (val) {
        let that = this
        if (val) {
          that.slots[0].values = val
        }
      }
    },
    created () {
    },
    data () {
      return {
        pickerValue: '',
        selected: '',
        showPicker: false,
        slots: [
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'left'
          }
        ]
      }
    },
    methods: {
      onValuesChange (picker, values) {
        this.selected = values
      },
      sure () {
        let that = this
        this.showPicker = false
        this.$emit('sureAction', that.selected)
      },
      cancel () {
        this.showPicker = false
        this.$emit('cancelAction', this.showPicker)
      },
      openPicker () {
        this.$refs.picker.open()
      },
      bodyScroll (event) {
        event.preventDefault()
      },
      forbidBodyScroll () {
        document.getElementsByClassName('projectContent')[0].addEventListener('touchmove', this.bodyScroll, false)
      },
      allowBodyScroll () {
        document.getElementsByClassName('projectContent')[0].removeEventListener('touchmove', this.bodyScroll, false)
      }
    },
    mounted: function () {
      let that = this
      setTimeout(function () {
        that.slots[0].values = that.pickItem
      }, 500)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  #myPicker {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 500;
    left: 0;
    bottom: 0;
    .moda {
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 10;
    }
    .lines {
      width: 100%;
      height: 30px;
      border-top: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
      position: absolute;
      top: 8.2rem;
      left: 0;
    }
    .pickerContainer {
      background-color: #ffffff;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 200px;
      z-index: 100;
      .bar {
        display: flex;
        justify-content: space-around;
        color: #000;
        font-size: 1.2rem;
        height: 2rem;
        align-items: center;
        padding: 0.5rem 0;
        .sureBtn {
          color: #f06553;
        }
        .cancelBtn {
          color: #999999;
        }
      }
      .picker {
        display: block;
        position: absolute;
        left: 0;
        top: 30px;
        .picker-item {
          font-size: 1.2rem;
          color: #999999;
        }
        .picker-selected {
          color: #000000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// myPicker.vue?4ad7b2eb